import { http, noTokenHttp, accHttp } from "@/api/config.js";
import qs from "qs";
//cookie参数
let cookieList = document.cookie ? document.cookie.split(";") : [];
let cookies = {};
cookieList.forEach((item) => {
  if (!cookies[item.split("=")[0].trim()])
    cookies[item.split("=")[0].trim()] = item.split("=")[1];
});

//考试信息
export const GetUserExamsApi = (data) => {
  data.userId = cookies["user-idcon"];
  for (let key in data) {
    if (data[key] === "") delete data[key];
  }
  data.fromStart = 0;
  return http({
    url: `/userExams?${qs.stringify(data, { arrayFormat: "repeat" })}`,
    method: "GET",
  });
};

//获取试卷
export const GetPaperApi = (id) => {
  return http({
    url: `papers/${id}`,
    method: "GET",
  });
};
//开始考试
// userIdCon：用户编号
// examIdCon：考试编号
// startTime：1
export const SetExamTimeApi = (data) => {
  data.userIdCon = cookies["user-idcon"];
  data.startTime = 1;
  for (let key in data) {
    if (data[key] === "") delete data[key];
  }
  return http({
    url: `userExams/update?${qs.stringify(data, { arrayFormat: "repeat" })}`,
    method: "POST",
  });
};
//获取考试的缓存
export const GetResumeApi = (examId) => {
  return http({
    url: `/user-exam-datas/${examId}`,
    method: "GET",
  });
};
//设置缓存
//  ◦ answers：作答数据（json<String：String>格式字串，{questionId1:作答 1,questionId2:作答
//   2…}） ◦ audios：音频播放位置（json<String：Integer>格式字串，{questionId1:时长 1,questionId2:
//   时长 2…}） ◦ remaining：考试剩余时间（数字，单位：秒）
//   ◦ submit：交卷标记（数字，0：仅保存作答，1：手动交卷，2：自动交卷）
//   ◦ syncScore：评分方式（数字，0：异步评分[默认]，1：同步评分）
//   ◦ version：数据版本（长整数）
// examId
export const SetResumeApi = (data) => {
  data.submit = 0;
  for (let key in data) {
    if (data[key] === "") delete data[key];
  }
  if (data.answers) data.answers = JSON.stringify(data.answers);
  if (data.audios) data.audios = JSON.stringify(data.audios);
  if (data.paperTime) data.paperTime = JSON.stringify(data.paperTime);
  if (data.interruptMark)
    data.interruptMark = JSON.stringify(data.interruptMark);
  data.checkExam = 1;
  data.checkUserExam = 1;
  return http({
    url: `/user-exam-datas/insert`,
    method: "POST",
    data: qs.stringify(data, {
      arrayFormat: "repeat",
    }),
  });
};
//交卷
export const SubmitExamApi = (data) => {
  for (let key in data) {
    if (data[key] === "") delete data[key];
  }
  if (data.answers) data.answers = JSON.stringify(data.answers);
  if (data.audios) data.audios = JSON.stringify(data.audios);
  if (data.paperTime) data.paperTime = JSON.stringify(data.paperTime);
  data.checkExam = 0;
  data.checkUserExam = 0;
  return http({
    url: `/user-exam-datas/insert`,
    method: "POST",
    data: qs.stringify(data, {
      arrayFormat: "repeat",
    }),
  });
};
//获取预览试卷
export const GetPreviewPaperApi = (id) => {
  // 身份判断;
  if (cookies["user-role"] != 2) {
    return new Promise(function (resolve) {
      resolve({
        msg: "无权限查看试卷",
        status: 403,
      });
    });
  }
  return http({
    url: `papers/${id}`,
    method: "GET",
  });
};
export const TrialPaperApi = (skill) => {
  return noTokenHttp.get(`/notIntercepts/tasteUserExam?skill=${skill}`);
};

// 用户考试数据准备/userExams/pre
export const UserExamsPreApi = (id) => {
  return http.post(`/userExams/pre?examId=${id}`);
};
//考试锁
export const LockExamApi = (data) => {
  data.userId = cookies["user-idcon"];
  return accHttp({
    url: `/locks`,
    method: "POST",
    data: qs.stringify(data, {
      arrayFormat: "repeat",
    }),
  });
};
export const UnlockExamApi = (data) => {
  data.userId = cookies["user-idcon"];
  return accHttp({
    url: `/locks/${data.userId}/${data.bizId}`,
    method: "DELETE",
  });
};
export const GetLockExamApi = (data) => {
  data.userId = cookies["user-idcon"];
  return accHttp({
    url: `/locks/${data.userId}/${data.bizId}`,
    method: "GET",
  });
};
export const GetAudioApi = (src) => {
  return http({
    url: src,
    method: "GET",
    responseType: "blob",
  });
};
